import PdImage from '@/components/pd-image/pd-image'
import PdTextMatchSup from '@/components/pd-text-match-sup/pd-text-match-sup'
import clsx from 'clsx'
import { FC } from 'react'
import { SemanticTextTag } from '@/common/pd-meta-components-types'
import SemanticText from '@/components/standard/semantic-text'

const TagItem: FC<{
  mediaUrl?: string
  title?: string
  desc?: string
  fontColor?: string
  contentAlign?: 'left' | 'center'
  iconAlign?: 'left' | 'center' | 'right'
  containerClassName?: string
  mediaClassName?: string
  titleClassName?: string
  titleTag?: SemanticTextTag | null
  descClassName?: string
}> = ({
  mediaUrl,
  title,
  desc,
  fontColor,
  contentAlign = 'left',
  iconAlign,
  containerClassName,
  mediaClassName,
  titleClassName,
  titleTag,
  descClassName,
}) => {
  // 文字对齐：传了 iconAlign 时跟随 iconAlign，否则跟随 contentAlign
  const textAlignClass = iconAlign
    ? { left: 'text-left', center: 'text-center', right: 'text-right' }[iconAlign]
    : (contentAlign === 'left' ? 'text-left' : 'text-center')

  return (
    <div
      className={clsx(
        'flex flex-col flex-1',
        containerClassName,
        contentAlign === 'left' ? 'items-start' : 'items-center'
      )}
    >
      {mediaUrl && (
        <div
          className={clsx(
            'w-12 h-12 laptop:w-20 laptop:h-20',
            'mb-3 laptop:mb-6',
            iconAlign && iconAlign === 'left' && 'self-start',
            iconAlign && iconAlign === 'right' && 'self-end',
            iconAlign && iconAlign === 'center' && 'self-center',
            mediaClassName
          )}
        >
          <PdImage src={mediaUrl} enableMask={false} width={'100%'} height={'100%'} />
        </div>
      )}
      {title && (
        <SemanticText
          as={titleTag}
          defaultTag="h3"
          className={clsx(
            'w-full font-semibold whitespace-pre-wrap',
            'text-fc-primary pd-second-title',
            'mb-1 laptop:mb-2',
            textAlignClass,
            titleClassName
          )}
          style={{ color: fontColor }}
        >
          <PdTextMatchSup className="" supClassName="" text={title}></PdTextMatchSup>
        </SemanticText>
      )}
      {desc && (
        <p
          className={clsx(
            'w-full whitespace-pre-wrap pd-third-title',
            'text-fc-secondary break-words',
            textAlignClass,
            descClassName
          )}
          style={{ color: fontColor }}
        >
          <PdTextMatchSup className="" supClassName="" text={desc}></PdTextMatchSup>
        </p>
      )}
    </div>
  )
}

export default TagItem
